export const DataType = {
    VOICE: 1,
    TEXT: 2,
};
